import axios from './http'

export function getSupplierList (token) {
  return axios({
    url: '/api/package-explorer/getSupplierList',
    headers: {
      'authorization': token
    },
    method: 'post'
  })
}


export function getBundle (token, data) {
  return axios({
    url: '/api/package-explorer/getBundle',
    headers: {
      'authorization': token
    },
    method: 'post',
    data: data
  })
}
